export default __webpack_public_path__ + "static/media/04-VEH-(4-3).04e5608d.jpg";